<template>
  <div class="mt-5">
    <b-row>
      <b-col cols="10" class="text-center heading p-1  text-white">
        {{ headtitle }}
      </b-col>
    </b-row>
    <div class="border overflowauto p-2 ">
      <b-row
        v-for="(data, index) in tableItems"
        :key="headtitle + index.toString()"
        class="m-1 changebackground"
      >
        <b-col sm="12" md="12" class="bg-white">
          <span class=" text-white  px-3 numberStyle">{{
            formatIndex(index + 1)
          }}</span>
        </b-col>
        <table
          class="fullWidth table-responsive-lg  text-center "
          cellpadding="0"
        >
          <tr>
            <th
              v-for="heading in primaryHeadData"
              :key="heading"
              class="pt-3"
              >{{ heading }}</th
            >
          </tr>
          <tr>
            <td>{{ data.notificationdate }} </td>
            <td>{{ data.creditorinfo }} </td>
            <td>{{ data.acctype }} </td>
            <td>{{ data.reported }} </td>
            <td>{{ data.creditlimit }} </td>
            <td>{{ data.balance }} </td></tr
          >
          <tr>
            <th
              v-for="heading in secondaryHeadData"
              :key="heading"
              class="pt-3"
              :colspan="heading === 'STATUS' ? 2 : 1"
              >{{ heading }}</th
            >
          </tr>
          <tr>
            <td>Monday</td>
            <td>Monday</td>
            <td>Monday</td>
            <td>Monday</td>
            <td colspan="2">Monday</td>
          </tr>
        </table>

        <b-col sm="12" md="12" class="bg-white text-right ">
          <b-link>Add Remark</b-link>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    subFields: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headtitle: this.title,
      tableItems: this.items,
      primaryHeadData: this.fields,
      secondaryHeadData: this.subFields,
    }
  },
  methods: {
    formatIndex(number) {
      let s = number.toString()
      while (s.length < 3) s = '0' + s
      return s
    },
  },
}
</script>

<style scoped>
.heading {
  margin: auto;
  background: #4b868f;
}
.overflowauto {
  /* height: 400px; */
  overflow-y: auto;
  overflow-x: hidden;
}
.fullWidth {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}
.border {
  border: 1px solid #777676;
}
.fullWidth > tr > th,
td {
  border: 1px solid #f2f2f2;
  padding: 5px;
  font-size: 0.9375rem;
}
.numberStyle {
  background: #4b868f;
}
.changebackground:nth-child(odd) {
  background: #eee;
}
.changebackground:nth-child(even) {
  background: #fff;
}
</style>
